module.exports = __webpack_public_path__ + "img/location-dot-solid.9fa7c32d.svg";